module.exports = __webpack_public_path__ + "../resources/img/ic_error_code_default.d83ce430.svg";